import { SitesSelectors } from '@src/modules/sites';
import { createSelector } from 'reselect';

export const selectGlobalFetching = createSelector(
  state => state.config,
  SitesSelectors.getIsFetchingSites,
  (state, isFetchingSites) => state.isCreatingDraft || state.isFetching || isFetchingSites
);
